<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
  <app-sub-header [pageTitle]="'Cars' | translate"></app-sub-header>

  <div class="padded-container">
    <div *ngIf="carListResponse?.cars?.length">
      <dx-text-box
        [(ngModel)]="searchText"
        [showClearButton]="true"
        [valueChangeEvent]="'input'"
        placeholder="{{ 'SearchCar' | translate }}"
        class="full-width-button"
        style="margin-bottom: 10px;"
      ></dx-text-box>
      <div class="car-list-box">
        <ng-container *ngIf="filteredCars.length > 0; else noMatch">
          <div *ngFor="let car of filteredCars">
            <dx-button 
              type="default" 
              class="full-width-button"
              (click)="car.id ? continueNextStep(car.id, car.description || '') : 0"
              [text]="car.driverReserved ? car.number + ' - ' + car.driverReserved : car.number"
              [icon]="car.servVoucherId ? 'optionsgear' : ''"
              [disabled]="!!car.driverReserved">
            </dx-button>
          </div>
        </ng-container>
        <ng-template #noMatch>
          <span>{{ 'NoCarsMatchSearch' | translate }}</span>
        </ng-template>
      </div>
      <dx-button 
        type="danger" 
        class="full-width-button"
        (click)="navigateToVoucher()"
        text="{{ 'Back' | translate }}">
      </dx-button>
    </div>

    <div *ngIf="!loading && !carListResponse?.cars?.length">
      <span>{{ 'NoAttachedCars' | translate }}</span>
      <dx-button 
        type="danger" 
        class="full-width-button"
        (click)="navigateToVoucher()"
        text="{{ 'Back' | translate }}">
      </dx-button>
    </div>
  </div>
</div>
